export let startMutedPosition = { muted: true };

const soundChecker = new Promise(function(resolve, reject) {

      const src = 'data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAC721kYXQhEAUgpBv/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3pwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcCEQBSCkG//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADengAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAAAsJtb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAAALwABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAB7HRyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAIAAAAAAAAALwAAAAAAAAAAAAAAAQEAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAC8AAAAAAAEAAAAAAWRtZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAAKxEAAAIAFXEAAAAAAAtaGRscgAAAAAAAAAAc291bgAAAAAAAAAAAAAAAFNvdW5kSGFuZGxlcgAAAAEPbWluZgAAABBzbWhkAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAADTc3RibAAAAGdzdHNkAAAAAAAAAAEAAABXbXA0YQAAAAAAAAABAAAAAAAAAAAAAgAQAAAAAKxEAAAAAAAzZXNkcwAAAAADgICAIgACAASAgIAUQBUAAAAAAfQAAAHz+QWAgIACEhAGgICAAQIAAAAYc3R0cwAAAAAAAAABAAAAAgAABAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAIAAAABAAAAHHN0c3oAAAAAAAAAAAAAAAIAAAFzAAABdAAAABRzdGNvAAAAAAAAAAEAAAAsAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ni40MC4xMDE=';

      const mutedSource = document.createElement('source');
      mutedSource.setAttribute('src', src);

      const unmutedSource = document.createElement('source');
      unmutedSource.setAttribute('src', src);

      const mutedVideo = document.createElement('video');
      mutedVideo.setAttribute('playsinline', 'true');
      mutedVideo.appendChild(mutedSource);
      mutedVideo.muted = true;

      const unmutedVideo = document.createElement('video');
      unmutedVideo.setAttribute('playsinline', 'true');
      unmutedVideo.setAttribute('class', 'vidos');
      unmutedVideo.appendChild(unmutedSource)

      mutedVideo.setAttribute('width', '0px');
      unmutedVideo.setAttribute('width', '0px');

      document.body.appendChild(unmutedVideo);

      unmutedVideo.play()
        .then(() => {
          startMutedPosition.muted = false;
          resolve({muted: false})
        })
        .catch(() => {
          document.body.appendChild(mutedVideo);
          mutedVideo.play()
            .then(() => {

              resolve({muted: true})
            })
            .catch((err) => {
              reject(err);

            })
        })
        .finally(() => {
          unmutedVideo.remove();
        })
    });

const timeoutCheck = new Promise( function (reject) {
      setTimeout(() => {
          reject();
      }, 3000)
  });

const isSoundAllowed = (videoAdContainer) => {
  Promise.race([soundChecker, timeoutCheck])
    .then((res) => {
      videoAdContainer.videoElement.muted = res.muted;
      if(res.muted === false) {
        document.querySelector('.sound-button').classList.remove('muted-button');
        const message = {
          prevideo: true,
          status: 'unmute',
        };
        const msgBody = JSON.stringify(message);
        window.parent.postMessage(msgBody, '*');
        window.top.postMessage(msgBody, '*');

        // delayed event for success :)
        setTimeout(() => {
          const message = {
            prevideo: true,
            status: 'unmute',
          };
          const msgBody = JSON.stringify(message);
          window.parent.postMessage(msgBody, '*');
          window.top.postMessage(msgBody, '*');
        }, 4000);
      }
    })
    .catch((err) => {
      videoAdContainer.videoElement.muted = true;
    })
};

export default isSoundAllowed;
